<template>
    <md-list-item>
        <md-icon v-if="isCurrentVersion(version.id)">label</md-icon>
        <md-icon v-else>label_outline</md-icon>
        <div class="md-list-text-container">
            <span>{{version.name}}</span>
            <span>{{getFormattedDate(version)}}</span>
            <md-tooltip md-direction="bottom">{{getFormattedDate(version)}}</md-tooltip>
        </div>
        <md-button class="md-icon-button md-list-action" @click="deleteVersion(version.id)" 
            v-if="(user.uid === ownerUID || user.uid === version.creator) && user.active_pay">
            <md-icon>delete</md-icon>
            <md-tooltip md-direction="top">Delete Version</md-tooltip>
        </md-button>
        <md-button class="md-icon-button md-list-action" @click="promoteVersion(version.id)" 
            v-if="user.uid === ownerUID && user.active_pay">
            <md-icon>vertical_align_top</md-icon>
            <md-tooltip md-direction="top">Make Live</md-tooltip>
        </md-button>
        <md-button class="md-icon-button md-list-action" @click="setActiveVersion(version.id)">
            <md-icon>launch</md-icon>
            <md-tooltip md-direction="top">Show Version</md-tooltip>
        </md-button>
    </md-list-item>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';

const Version = {
    name: 'Version',
    props: ['project', 'version'],
    data: function() {
        return {};
    },
    computed: {
        ...mapGetters([
            'ownerUID',
            'user',
            'versions',
            'currentVersion'
        ])
    },
    methods: {
        setActiveVersion(versionID) {
            if (versionID === null) {
                this.$router.replace(`/project/${this.project.id}`);
            }

            const vIndex = this.versions.findIndex(v => v.id === versionID);
            if (vIndex > -1) {
                this.$router.replace(`/project/${this.project.id}/version/${versionID}/`);
            }
        },
        isCurrentVersion(versionID) {
            if (this.currentVersion) {
                return this.currentVersion.id === versionID;
            }

            return false;
        },
        deleteVersion(versionID) {
            this.$emit('deleteVersion', versionID);
        },
        promoteVersion(versionID) {
            this.$emit('promoteVersion', versionID);
        },
        getFormattedDate(version) {
            return moment(version.created).format('MM/DD/YYYY hh:mm:ss a');
        }
    }
};
export default Version;

</script>

<style lang="scss">
.ql-version-list {
    .md-list-item {
        margin-top: .75em;
        line-height: 40px;
        .md-list-item-container > .md-icon:first-child  {
            margin-right: .5em !important;
        }
        .md-list-item-container > .md-button:first-child {
            margin-left: 0 !important;
        } 
    }
}
.md-sidenav-content > form {
    padding-left: .5em;
}
</style>


// WEBPACK FOOTER //
// version.vue?3158850e